import { render, staticRenderFns } from "./EgiftOrders.vue?vue&type=template&id=453f43a2"
import script from "./EgiftOrders.vue?vue&type=script&lang=js"
export * from "./EgiftOrders.vue?vue&type=script&lang=js"
import style0 from "./EgiftOrders.vue?vue&type=style&index=0&id=453f43a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports